module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/chisiamo-cosafacciamo/chisiamo-cosafacciamo.component.scss
// module id = ./src/app/chisiamo-cosafacciamo/chisiamo-cosafacciamo.component.scss
// module chunks = main